module.exports = __webpack_public_path__ + "img/motor_no24.7845a814.jpg";